import { render } from "./InboxLayout.vue?vue&type=template&id=6638676a&scoped=true"
import script from "./InboxLayout.vue?vue&type=script&lang=js"
export * from "./InboxLayout.vue?vue&type=script&lang=js"

import "./InboxLayout.vue?vue&type=style&index=0&id=6638676a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6638676a"]])

export default __exports__